import { render, staticRenderFns } from "./nav-pagination.vue?vue&type=template&id=1de92835&scoped=true&"
import script from "./nav-pagination.vue?vue&type=script&lang=ts&"
export * from "./nav-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./nav-pagination.vue?vue&type=style&index=0&id=1de92835&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de92835",
  null
  
)

export default component.exports